<template>
  <!-- <dv-border-box-4 :color="['#266c6d', '#101d40']"> -->
  <div class="leftCharts-container">
    <div class="top-content">
      <h3 class="global-titleShadow">生产</h3>
      <div class="border-content">
        <div class="top-card">
          <h4>
            <div class="global-dot"></div>近30日产量趋势(双)
          </h4>
          <LineCharts
            :xAxisData="day30Arr"
            :yAxisData="output30Arr"
          ></LineCharts>
        </div>
        <div class="top-card">
          <h4>
            <div class="global-dot"></div>产线累计产量(双)
          </h4>
          <BarCharts
            :xAxisData="lineNameArr"
            :yAxisData="cumulativeArr"
            :yUnitType="'w'"
          ></BarCharts>
        </div>
      </div>
    </div>
    <div class="bottom-content">
      <h3 class="global-titleShadow">质量</h3>
      <div class="border-content">
        <h4>
          <div class="global-dot"></div>缺陷分析
        </h4>
        <PieCharts></PieCharts>
      </div>
    </div>
  </div>
  <!-- </dv-border-box-4> -->
</template>

<script>
import axios from 'axios';
import BarCharts from './LeftCharts/BarCharts.vue';
import LineCharts from './LeftCharts/LineCharts.vue';
import PieCharts from './LeftCharts/PieCharts.vue';
import * as moment from 'moment';

export default {
  name: 'LeftCharts',
  components: {
    BarCharts,
    LineCharts,
    PieCharts
  },
  data () {
    return {
      day30Arr: [],
      day30Ago: moment().add(-29, 'd').format("YYYY-MM-DD"),
      dayToday: moment().add(1, 'd').format("YYYY-MM-DD"),
      output30Arr: [],
      lineNameArr: ['A2', 'D1', 'D2', 'Y1', 'E1', 'JDD3', 'S', 'X'],
      cumulativeArr: [],
      timer: '',
    }
  },
  mounted () {
    for (let i = 1; i < 31; i++) {
      this.day30Arr.push(i)
    }
    this.handleOutput30Req()
    this.handleCumulativeReq()
    this.timer = setInterval(() => {
      this.handleOutput30Req()
      this.handleCumulativeReq()
    }, 1000 * 60 * 5)
  },
  methods: {
    handleAdd (arr) {
      let result = 0;
      for (let ele of arr) {
        result += Number(ele)
      }
      return result
    },
    // handleOutput30Req () {
    //   let total = []
    //   let output30ReqArr = [
    //     this.$axios({
    //       method: 'get',
    //       url: 'https://api.a2.zs-tek.com/BigExhibition/BigExhibition/GetHistoryProcessDayCountData/29',
    //     }),
    //     this.$axios({
    //       method: 'get',
    //       url: 'https://api.d1.zs-tek.com/Production/GetCountByTimeRange',
    //       params: {
    //         beginTime: this.day30Ago,
    //         endTime: this.dayToday,
    //         timeRangeType: 2
    //       }
    //     }),
    //     this.$axios({
    //       method: 'get',
    //       url: 'https://api.d2.zs-tek.com/Production/GetCountByTimeRange',
    //       params: {
    //         beginTime: this.day30Ago,
    //         endTime: this.dayToday,
    //         timeRangeType: 2
    //       }
    //     }),
    //     // this.$axios({
    //     //   method: 'get',
    //     //   url: 'https://api.y1.zs-tek.com/Production/GetCountByTimeRange',
    //     //   params: {
    //     //     beginTime: this.day30Ago,
    //     //     endTime: this.dayToday,
    //     //     timeRangeType: 2
    //     //   }
    //     // }),
    //     this.$axios({
    //       method: 'get',
    //       url: 'https://api.e1.zs-tek.com/Production/GetCountByTimeRange',
    //       params: {
    //         beginTime: this.day30Ago,
    //         endTime: this.dayToday,
    //         timeRangeType: 2
    //       }
    //     }),
    //     this.$axios({
    //       method: 'get',
    //       url: 'https://api.jdd3.zs-tek.com/Production/GetCountByTimeRange',
    //       params: {
    //         beginTime: this.day30Ago,
    //         endTime: this.dayToday,
    //         timeRangeType: 2
    //       }
    //     }),
    //     this.$axios({
    //       method: 'get',
    //       url: 'https://api.s1.zs-tek.com/Production/GetCountByTimeRange',
    //       params: {
    //         beginTime: this.day30Ago,
    //         endTime: this.dayToday,
    //         timeRangeType: 2
    //       }
    //     }),
    //     this.$axios({
    //       method: 'get',
    //       url: 'https://api.x.zs-tek.com/Production/GetCountByTimeRange',
    //       params: {
    //         beginTime: this.day30Ago,
    //         endTime: this.dayToday,
    //         timeRangeType: 2
    //       }
    //     }),
    //   ]
    //   this.$axios.all(output30ReqArr).then(this.$axios.spread((a2, d1, d2, e1, jdd3, s1, x) => {
    //     for (let i = 0; i < 30; i++) {
    //       total.push(this.handleAdd([
    //         a2.data[i].value,
    //         d1.data[i].count,
    //         d2.data[i]?.count ?? 0,
    //         0,
    //         e1.data[i]?.count ?? 0,
    //         jdd3.data[i].count,
    //         s1.data[i].count,
    //         x.data[i].count,
    //       ]))
    //     }
    //     this.output30Arr = total
    //   })).catch((err) => {
    //     this.$message.error('30日总产量通讯异常')
    //   })
    // },
    handleOutput30Req () {
      let total = []
      let output30ReqArrTem = []
      let output30ReqArr = [
        {
          method: 'get',
          url: 'https://api.a2.zs-tek.com/BigExhibition/BigExhibition/GetHistoryProcessDayCountData/29',
        },
        {
          method: 'get',
          url: 'https://api.d1.zs-tek.com/Production/GetCountByTimeRange',
          params: {
            beginTime: this.day30Ago,
            endTime: this.dayToday,
            timeRangeType: 2
          }
        },
        {
          method: 'get',
          url: 'https://api.d2.zs-tek.com/Production/GetCountByTimeRange',
          params: {
            beginTime: this.day30Ago,
            endTime: this.dayToday,
            timeRangeType: 2
          }
        },
        {
          method: 'get',
          url: 'https://api.y1.zs-tek.com/Production/GetCountByTimeRange',
          params: {
            beginTime: this.day30Ago,
            endTime: this.dayToday,
            timeRangeType: 2
          }
        },
        {
          method: 'get',
          url: 'https://api.e1.zs-tek.com/Production/GetCountByTimeRange',
          params: {
            beginTime: this.day30Ago,
            endTime: this.dayToday,
            timeRangeType: 2
          }
        },
        {
          method: 'get',
          url: 'https://api.jdd3.zs-tek.com/Production/GetCountByTimeRange',
          params: {
            beginTime: this.day30Ago,
            endTime: this.dayToday,
            timeRangeType: 2
          }
        },
        {
          method: 'get',
          url: 'https://api.s1.zs-tek.com/Production/GetCountByTimeRange',
          params: {
            beginTime: this.day30Ago,
            endTime: this.dayToday,
            timeRangeType: 2
          }
        },
        {
          method: 'get',
          url: 'https://api.x.zs-tek.com/Production/GetCountByTimeRange',
          params: {
            beginTime: this.day30Ago,
            endTime: this.dayToday,
            timeRangeType: 2
          }
        },
      ]
      // this.$axios.all(output30ReqArr).then(this.$axios.spread((a2, d1, d2, e1, jdd3, s1, x) => {
      //   for (let i = 0; i < 30; i++) {
      //     total.push(this.handleAdd([
      //       a2.data[i].value,
      //       d1.data[i].count,
      //       d2.data[i]?.count ?? 0,
      //       0,
      //       e1.data[i]?.count ?? 0,
      //       jdd3.data[i].count,
      //       s1.data[i].count,
      //       x.data[i].count,
      //     ]))
      //   }
      //   this.output30Arr = total
      // })).catch((err) => {
      //   this.$message.error('30日总产量通讯异常')
      // })
      Promise.allSettled(output30ReqArr.map(({ method, url, params }) =>
      // fetch(`${url}?${new URLSearchParams(params).toString()}`, { method, timeout: 5000 })
      //   .then(response => response.json())
      //   .catch(error => ({ error }))
      {
        return axios({
          method: method, // 请求方法，如 'GET'、'POST'
          url: `${url}?${new URLSearchParams(params).toString()}`, // 请求地址
          timeout: 3500, // 设置超时时间为3.5秒
        })
          .then(response => response.data) // 提取响应数据
          .catch(error => ({ error })); // 捕获请求错误
      }
      ))
        .then((results) => {
          results.forEach((result, index) => {
            if (result.status === "fulfilled") {
              if (Array.isArray(result.value)) {
                output30ReqArrTem[index] = result.value;
              } else {
                output30ReqArrTem[index] = []
              }
            } else if (result.status === "rejected") {
              // console.log("Rejected:", result.reason, "Name:", index)
            }
          })
          for (let i = 0; i < 30; i++) {
            total.push(this.handleAdd([
              output30ReqArrTem[0][i]?.value ?? 0,
              output30ReqArrTem[1][i]?.count ?? 0,
              output30ReqArrTem[2][i]?.count ?? 0,
              0,
              output30ReqArrTem[4][i]?.count ?? 0,
              output30ReqArrTem[5][i]?.count ?? 0,
              output30ReqArrTem[6][i]?.count ?? 0,
              output30ReqArrTem[7][i]?.count ?? 0,
            ]))
          }
          this.output30Arr = total;
        });
    },
    // handleCumulativeReq () {
    //   let cumulativeReqArr = [
    //     this.$axios({ method: 'get', url: 'https://api.a2.zs-tek.com/BigExhibition/BigExhibition/GetAllProcessData' }),
    //     this.$axios({ method: 'get', url: 'https://api.d1.zs-tek.com/Production/GetTotalCount' }),
    //     this.$axios({ method: 'get', url: 'https://api.d2.zs-tek.com/Production/GetTotalCount' }),
    //     // this.$axios({ method: 'get', url: 'https://api.y1.zs-tek.com/Production/GetTotalCount' }),
    //     this.$axios({ method: 'get', url: 'https://api.e1.zs-tek.com/Production/GetTotalCount' }),
    //     this.$axios({ method: 'get', url: 'https://api.jdd3.zs-tek.com/Production/GetTotalCount' }),
    //     this.$axios({ method: 'get', url: 'https://api.s1.zs-tek.com/Production/GetTotalCount' }),
    //     this.$axios({ method: 'get', url: 'https://api.x.zs-tek.com/Production/GetTotalCount' }),
    //   ]
    //   this.$axios.all(cumulativeReqArr).then(this.$axios.spread((a2, d1, d2, e1, jdd3, s1, x) => {
    //     this.cumulativeArr = [a2.data.processCount, d1.data, d2.data, 375, e1.data, jdd3.data, s1.data, x.data];
    //   })).catch((err) => {
    //     this.$message.error('累计产量通讯异常')
    //   })
    // },
    handleCumulativeReq () {
      let cumulativeArrTem = [];
      let cumulativeReqArr = [
        { method: 'get', url: 'https://api.a2.zs-tek.com/BigExhibition/BigExhibition/GetAllProcessData' },
        { method: 'get', url: 'https://api.d1.zs-tek.com/Production/GetTotalCount' },
        { method: 'get', url: 'https://api.d2.zs-tek.com/Production/GetTotalCount' },
        { method: 'get', url: 'https://api.y1.zs-tek.com/Production/GetTotalCount' },
        { method: 'get', url: 'https://api.e1.zs-tek.com/Production/GetTotalCount' },
        { method: 'get', url: 'https://api.jdd3.zs-tek.com/Production/GetTotalCount' },
        { method: 'get', url: 'https://api.s1.zs-tek.com/Production/GetTotalCount' },
        { method: 'get', url: 'https://api.x.zs-tek.com/Production/GetTotalCount' },
      ]
      // this.$axios.all(cumulativeReqArr).then(this.$axios.spread((a2, d1, d2, e1, jdd3, s1, x) => {
      //   this.cumulativeArr = [a2.data.processCount, d1.data, d2.data, 375, e1.data, jdd3.data, s1.data, x.data];
      // })).catch((err) => {
      //   this.$message.error('累计产量通讯异常')
      // })
      Promise.allSettled(cumulativeReqArr.map(({ method, url }) =>
      // fetch(url, { method, timeout: 5000 })
      //   .then(response => response.json())
      //   .catch(error => ({ error }))
      {
        return axios({
          method: method, // 请求方法，如 'GET'、'POST'
          url, // 请求地址
          timeout: 3500, // 设置超时时间为3.5秒
        })
          .then(response => response.data) // 提取响应数据
          .catch(error => ({ error })); // 捕获请求错误
      }
      ))
        .then((results) => {
          results.forEach((result, index) => {
            if (result.status === "fulfilled") {
              if (!isNaN(Number(result.value))) {
                cumulativeArrTem[index] = Number(result.value);
              } else if (!isNaN(Number(result.value?.processCount))) {
                cumulativeArrTem[index] = Number(result.value?.processCount);
              } else {
                cumulativeArrTem[index] = 0
              }
            } else if (result.status === "rejected") {
              // console.log("Rejected:", result.reason, "Name:", index)
            }
          })
          cumulativeArrTem[3] = 375;
          this.cumulativeArr = cumulativeArrTem;
        });
    },
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
}
</script>

<style scoped>
.leftCharts-container {
  color: #fff;
  text-align: left;
  padding: 15px 15px;
  box-sizing: border-box;
  height: 100%;
}

.top-content {
  height: 65%;
  /* background-color: antiquewhite; */
}

.top-card {
  margin-top: 5px;
}

.bottom-content {
  height: 35%;
  /* background-color: brown; */
}

h3 {
  font-size: 25px;
  line-height: 35px;
  padding-left: 20px;
  color: #0efcff;
  letter-spacing: 1px;
}

h4 {
  font-size: 22px;
  display: flex;
  align-items: center;
  text-indent: 4px;
  line-height: 44px;
}

.border-content {
  padding: 0px 16px 0 16px;
}
</style>
